import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Spinner } from '../ui';
import { useAdminAuth } from '../../hooks/useAdminAuth';

/**
 * Protected route wrapper for admin panel.
 * Verifies Firebase Custom Token with isAdmin claim via useAdminAuth.
 * Shows spinner while auth state is loading, redirects to /admin login if not authenticated.
 */
const AdminRoute: React.FC = () => {
  const { isAuthReady, isLoading } = useAdminAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (!isAuthReady) {
    return <Navigate to="/admin" replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
